<template>
  <div v-loading="loading" class="container-content-export-valuation">
    <div class="container-close-page"><font-awesome-icon icon="times" @click="closePage()" /></div>
    <div class="container-aviso-export-valuation mb-3">
      <button v-if="exportActive" class="brains-type1-btn" @click="initPrintPDF()">{{ $t('generate-report') }}</button>
      <button v-if="!exportActive" class="brains-type3-btn btn-disabled-export">{{ $t('generate-report') }}</button>
      <div class="fs-24 ff-semibold">{{ $t("important-notice") }}</div>
      <div class="fs-20">{{ $t("not-close-page-while-val-generating") }}</div>
    </div>
    <div id="container-paginas-export-valuation" class="container-paginas-export-valuation">
      <!-- Pagina del resumen -->
      <pageExportVal v-if="checkVisiblePage('resumen')" id="export-val-resumen" :title="exportedData.exportTitle">
        <div class="container-data-page">
          <pageResumen
            :data="exportedData.valuationSave"
            :map-img="exportedData.imageMapExport"
            :map-resumen-position="exportedData.mapResumenPosition"
            @imageSV="imageSV"
            @imageSatellite="imageSatellite"
          />
        </div>
      </pageExportVal>
      <!-- Pagina de los comparables -->
      <pageExportVal v-if="checkVisiblePage('comparables')" id="export-val-comparables" :title="exportedData.exportTitle">
        <div class="container-data-page">
          <pageComparables :comparables="comparablesFirstPage" :map-img="exportedData.imageMapExport" :stock-table="exportedData.stockTableDataExport[0]" />
        </div>
      </pageExportVal>
      <span v-if="checkVisiblePage('comparables')">
        <pageExportVal v-for="(page, index) in comparablesOtherPage" id="export-val-comparables" :key="index + '-comp'" :title="exportedData.exportTitle">
          <div class="container-data-page"><pageComparablesOthers :comparables="page" /></div>
        </pageExportVal>
      </span>
      <!-- Pagina de las imagenes -->
      <span v-if="checkVisiblePage('imagenes') && groupedImages.length > 0">
        <pageExportVal v-for="(images, index) in groupedImages" id="export-val-imagenes" :key="index + '-image'" :title="exportedData.exportTitle">
          <div class="container-data-page"><pageImages :images="images" /></div>
        </pageExportVal>
      </span>
      <!-- Pagina del data -->
      <pageExportVal v-if="checkVisiblePage('data')" id="export-val-data" :title="exportedData.exportTitle">
        <div class="container-data-page"><pageData :data="filteredDataTables" /></div>
      </pageExportVal>
      <!-- Pagina de los POI -->
      <span v-if="checkVisiblePage('poi') && groupedPois.length > 0">
        <pageExportVal v-for="(pois, index) in groupedPois" id="export-val-poi" :key="index + '-poi'" :title="exportedData.exportTitle">
          <div class="container-data-page"><pagePois :pois="pois" /></div>
        </pageExportVal>
      </span>
      <!-- Pagina de las graficas -->
      <pageExportVal v-if="checkVisiblePage('graficas')" id="export-val-graficas" :title="exportedData.exportTitle">
        <div class="container-data-page"><pageGraficas :data="exportedData.exportCharts" /></div>
      </pageExportVal>
    </div>
  </div>
</template>

<script>
import pageExportVal from './pageExportVal'
import pageResumen from './pageResumen'
import pageComparables from './pageComparables'
import pageComparablesOthers from './pageComparablesOthers'
import pageImages from './pageImages'
import pageData from './pageData'
import pagePois from './pagePois'
import pageGraficas from './pageGraficas'

import { downloadimage } from '@/api/comparables'
import html2pdf from 'html2pdf.js'

export default {
  name: 'ContentExportValuations',
  components: { pageExportVal, pageResumen, pageComparables, pageComparablesOthers, pageImages, pageData, pagePois, pageGraficas },
  data() {
    return {
      loading: false,
      assetImages: [],
      exportActive: false
    }
  },
  computed: {
    /**
     * Se cargan los datos para pintar en la vista del PDF
     */
    exportedData() {
      return JSON.parse(localStorage.getItem('data_export_val')) || ''
    },
    /**
     * Se seleccionan los primeros 35 comparables, ya que son los que entran por cada columna
     */
    comparablesFirstPage() {
      return { currentComparables: [], selectedcomparables: this.exportedData.comparables.selectedcomparables }
      // var comps = {
      //   currentComparables: [],
      //   selectedcomparables: []
      // }

      // this.exportedData.comparables.currentComparables.forEach((comp, index) => {
      //   if (index < 35) {
      //     var isSelected = false
      //     this.exportedData.comparables.selectedcomparables.forEach((selected) => {
      //       if (selected.iD_comparable === comp.iD_comparable) {
      //         isSelected = true
      //         comps.selectedcomparables.push(comp)
      //       }
      //     })

      //     if (!isSelected) {
      //       comps.currentComparables.push(comp)
      //     }
      //   }
      // })

      // return comps
    },
    /**
     * Se obtienen los comparables divididos por paginas, cada pagina puede tener un maximo de 70 comparables
     * dividido en 2 columnas de 35 comparables
     * Actualmente pintamos un maximo de 5 paginas con comparables, se pueden llegar a pintar unos 370
     */
    comparablesOtherPage() {
      const totperpage = 60
      const totpercolumn = 30
      var totalCompOtherPages = this.exportedData.comparables.currentComparables.length - this.exportedData.comparables.selectedcomparables.length
      var numberPages = Math.ceil(totalCompOtherPages / totperpage)
      var otherComparables = []

      // Se obtienen los comparables que no estan en la primera pagina
      this.exportedData.comparables.currentComparables.forEach((comp, index) => {
        var isSelected = false
        this.exportedData.comparables.selectedcomparables.forEach((selected) => {
          if (selected.iD_comparable === comp.iD_comparable) {
            isSelected = true
          }
        })
        if (!isSelected) {
          otherComparables.push(comp)
        }
      })

      var result = []

      // Se crea el objeto de las paginas, teniendo datos para la columna de la izquierda y de la derecha
      for (let i = 1; i <= numberPages; i++) {
        result.push({
          leftCol: {
            currentComparables: [],
            selectedcomparables: []
          },
          rightCol: {
            currentComparables: [],
            selectedcomparables: []
          }
        })
      }

      // Se itera sobre todos los comparables y se coloca en el objeto correspondiente dependiendo de su indice
      // Si dividimos el indice entre 70 (numero maximo de comp por pagina) obtenemos en que pagina esta
      otherComparables.forEach((comp, index) => {
        const page = Math.ceil((index + 1) / totperpage)

        // Se colocan los comparables en su pagina correspondiente mirando si el indice del comparable - numero comps base (35) es inferior
        // o superior a 0, si es inferior a 0, por tanto va en la columna de la izquierda, si es superior en la de la derecha
        // en cada pagina se da un salto de 70 comps, suma total de la pagina
        if (page === 1) {
          if (index - totpercolumn < 0) {
            result[page - 1].leftCol.currentComparables.push(comp)
          } else {
            result[page - 1].rightCol.currentComparables.push(comp)
          }
        } else if (page === 2) {
          if (index - (totpercolumn * (page + 1)) < 0) {
            result[page - 1].leftCol.currentComparables.push(comp)
          } else {
            result[page - 1].rightCol.currentComparables.push(comp)
          }
        } else if (page === 3) {
          if (index - (totpercolumn * (page + 2)) < 0) {
            result[page - 1].leftCol.currentComparables.push(comp)
          } else {
            result[page - 1].rightCol.currentComparables.push(comp)
          }
        } else if (page === 4) {
          if (index - (totpercolumn * (page + 3)) < 0) {
            result[page - 1].leftCol.currentComparables.push(comp)
          } else {
            result[page - 1].rightCol.currentComparables.push(comp)
          }
        } else if (page === 5) {
          if (index - (totpercolumn * (page + 4)) < 0) {
            result[page - 1].leftCol.currentComparables.push(comp)
          } else {
            result[page - 1].rightCol.currentComparables.push(comp)
          }
        } else if (page === 6) {
          if (index - (totpercolumn * (page + 5)) < 0) {
            result[page - 1].leftCol.currentComparables.push(comp)
          } else {
            result[page - 1].rightCol.currentComparables.push(comp)
          }
        }
      })
      return result
    },
    /**
     * Se agrupan las imagenes en grupos de 8 para cada pagina, teniendo asi tantas paginas como grupos de imagenes haya
     */
    groupedImages() {
      const totalPaginas = Math.ceil(this.assetImages.length / 8)
      var groups = []

      for (let i = 1; i <= totalPaginas; i++) {
        groups.push([])
      }

      this.assetImages.forEach((img, index) => {
        const page = Math.ceil((index + 1) / 8)
        groups[page - 1].push(img)
      })

      return groups
    },
    /**
     * Se eliminan todas las tablas que se quieran mostrar, actualmente solo se van a mostrar las siguientes tablas:
     * Sale Market Residential, Rent Market Residential, Brokers Residential, Population, Dwellings, Economy
     */
    filteredDataTables() {
      // debugger
      if (this.exportedData.dataSidebarExport === null) return []
      return {
        residentialData: this.exportedData.dataSidebarExport.residentialData.filter((item) => {
          return item.bloque === 1 || item.bloque === 3 || item.bloque === 6
        }),
        genericData: this.exportedData.dataSidebarExport.genericData.filter((item) => {
          return item.bloque === 3 || item.bloque === 4
        })
      }
    },
    /**
     * Numero total de pois que tenemos
     */
    totalPois: {
      get() {
        return this.exportedData.pois.reduce((acc, item) => acc + item.pois.length, 0)
      }
    },
    /**
     * Se filtran los pois, ya que los pois que sean superiores a 27 no entran en una columna, por lo tanto se van a subdividir hasta que entren todos
     */
    filteredPois() {
      var filtered = []

      // Se itera sobre todos los pois buscando cuales son los mas largos
      const poisperpage = 20
      this.exportedData.pois.forEach((poi, index) => {
        // Si encontramos uno que sea mas largo que 27, lo separamos por por paquetes de 27 en objetos POI cumpliendo los datos de su categoria
        if (poi.pois.length >= poisperpage) {
          const totalPaginas = Math.ceil(poi.pois.length / poisperpage)

          var groups = []

          for (let i = 1; i <= totalPaginas; i++) {
            groups.push({ pois: [], tipo: poi.tipo, tipo_literal: poi.tipo_literal })
          }

          poi.pois.forEach((item, index) => {
            const page = Math.ceil((index + 1) / poisperpage)
            groups[page - 1].pois.push(item)
          })

          groups.forEach((item) => {
            filtered.push(item)
          })
        } else {
          // Si no es muy largo, se añade como estaba antes
          filtered.push(poi)
        }
      })

      return filtered
    },
    /**
     * Se agrupan los pois para que entren todos en diferentes paginas, con un maximo de 60 pois por pagina
     */
    groupedPois() {
      const totalpoispage = 40
      const totalPaginas = Math.ceil(this.totalPois / totalpoispage)
      var groups = []

      for (let i = 1; i <= totalPaginas; i++) {
        groups.push([])
      }

      var recuentoActual = 0

      this.filteredPois.forEach((poi, index) => {
        recuentoActual += poi.pois.length
        const page = Math.ceil(recuentoActual / totalpoispage)

        groups[page - 1].push(poi)
      })

      return groups
    },
    /**
     * Nombre del archivo
     * Si no hay nombre de la valoracion el formato será ExportValuation + fecha
     * Si hay nombre el formato será nombre + fecha
     */
    fileName() {
      var today = new Date()

      var date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear()

      if (this.exportedData.valuationSave.valuationSavedName !== '') {
        return this.exportedData.valuationSave.valuationSavedName + '-' + date
      } else {
        return 'ExportValuation-' + date
      }
    }
  },
  mounted() {
    this.loadValuationImages()
    setTimeout(() => {
      this.exportActive = true
    }, 6000)
  },
  methods: {
    closePage() {
      // window.close()
      // this.$router.push({ name: 'valuation' })
      // this.$router.back()
      this.$parent.$parent.visibleexport = false
    },
    imageSV(res) {
      this.assetImages.push(res)
    },
    imageSatellite(res) {
      this.assetImages.push(res)
    },
    loadValuationImages() {
      this.assetImages.push(this.exportedData.imageMapExport)

      if (this.exportedData.valuationSave.imagesUrl === undefined) return

      const vm = this
      this.exportedData.valuationSave.imagesUrl.forEach((img) => {
        downloadimage({ url: img })
          .then((res) => {
            var reader = new FileReader()
            reader.readAsDataURL(res.data)
            reader.onloadend = function() {
              vm.assetImages.push(reader.result)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      })
    },
    checkVisiblePage(page) {
      var included = false
      this.exportedData.exportValuationsOptions.forEach((item) => {
        if (item.id === page) {
          included = item.checked
        }
      })

      return included
    },
    initPrintPDF() {
      this.loading = true
      //   this.$emit("manageLoadingPrint", true);
      //   this.$emit("initPrint", true);

      var paginas = document.getElementsByClassName('page-pdf')
      paginas.forEach(pagina => {
        pagina.classList.remove('mb-2')
        pagina.style.border = 'none'
      })
      setTimeout(() => {
        this.generatePDF()
      }, 4000)
    },
    async generatePDF() {
      var element = document.getElementById('container-paginas-export-valuation')

      var opt = {
        margin: [10, 20, 0, 10],
        filename: this.fileName + '.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2 },
        pagebreak: { mode: 'avoid-all' },
        allowTaint: true,
        useCORS: true,
        jsPDF: {
          unit: 'px',
          //   format: [1410, 795],
          format: [1630, 920],
          // format: [1880, 1060],
          // format: [1400, 800],
          orientation: 'landscape'
        }
      }

      html2pdf()
        .set(opt)
        .from(element)
        .toPdf()
        .save()
        .then(() => {
          this.endPrintPDF()
        })
    },
    endPrintPDF() {
      var paginas = document.getElementsByClassName('page-pdf')

      paginas.forEach(pagina => {
        pagina.classList.add('mb-2')
        pagina.style.border = '1px solid black'
      })

      this.loading = false
      this.$parent.$parent.visibleexport = false
      //   this.$emit("manageLoadingPrint", false);
      //   this.$emit("initPrint", false);
    }
  }
}
</script>

<style lang="scss" scoped>
.container-content-export-valuation {
  width: 100%;
  height: 22vh;
  /*height: 100%;*/
  /*display: grid;*/
  justify-content: center;
  grid-template-rows: 5% 25% auto;
  overflow: hidden;
  position: relative;
  padding-top: 30px;

  .container-aviso-export-valuation {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 60%;
    margin: auto;
    padding-top: 0;
    padding-bottom: 20px;
    text-align: center;
    line-height: 1.5;
  }
}

.container-data-page {
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-disabled-export {
  cursor: default;

  &:hover {
    background-color: lightgrey;
  }
}

.container-close-page {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 32px;
  color: #1e3cff;

  svg {
    cursor: pointer;
  }
}
</style>
